export const DragFlags = {
    isDragging: false,
    dragEndTimestamp: -Infinity,
    cancelDragMouseDownEvent: false
};
